<script setup>
import { gsap } from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollToPlugin)

function backToTop() {
  gsap.to(window, {
    scrollTo: { y: 0 },
    duration: 1.3,
    ease: 'power2.inOut',
  })
}

onMounted(() => {
  const script = document.createElement('script'),
    tag = document.getElementsByTagName('script')[0]
  script.src = 'https://cdn.iubenda.com/iubenda.js'
  tag.parentNode.insertBefore(script, tag)
})
</script>

<template>
  <div class="footer-menu row-40-25 p-top-m-1">
    <div class="footer-menu__content p-bottom-1">
      <!-- Logo -->
      <div class="footer-menu__logo">
        <nuxt-link
          class="anim-opacity"
          :to="
            localePath({
              name: 'index',
            })
          "
        >
          <img
            src="@/assets/img/logo-istituto-canossiano-white.png"
            alt="Istituto Canossiano"
            loading="lazy"
          />
        </nuxt-link>
      </div>
      <div class="footer-menu__button hide-for-large">
        <div class="wrapper">
          <div class="registro-container">
            <DefaultBtn
              text="Registro elettronico"
              content="https://web.spaggiari.eu/home/app/default/login.php"
              icon="curved-arrow"
              class="button-round-1 with-icon is-white"
            />
          </div>
        </div>
      </div>
      <div class="footer-menu__links">
        <div>
          <p class="text-s-1-b">
            Istituto Canossiano Conselve<br />
            Start Cooperativa Sociale Onlus<br />
            Piazza Cesare Battisti, 27<br />
            35026 - Conselve (PD)<br />
            P.I. 02652740180
          </p>
        </div>
        <div>
          <p class="text-xs-1 orari">
            La segreteria risponde telefonicamente<br />
            dal Lunedì al Venerdì dalle ore 09:00 alle ore 12:00
          </p>
          <br />
          <div class="bottom">
            <p class="text-s-1-b">
              <a href="tel:0497485330">Tel. 049 7485330</a><br />
              <a href="mailto:segreteria.conselve@startscs.it">segreteria.conselve@startscs.it</a>
            </p>
            <div class="up-button hide-for-large" @click="backToTop">
              <img src="@/assets/img/ico/circle-arrow-white.svg?url" alt="Up" />
            </div>
          </div>
        </div>
      </div>
      <div class="footer-menu__button show-for-large">
        <div class="wrapper">
          <div class="registro-container">
            <DefaultBtn
              text="Registro elettronico"
              content="https://web.spaggiari.eu/home/app/default/login.php"
              icon="curved-arrow"
              class="button-round-1 with-icon is-white"
            />
          </div>
          <div class="up-button" @click="backToTop">
            <img src="@/assets/img/ico/circle-arrow-white.svg?url" alt="Up" />
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-links text-xxs-1">
      <div class="policy">
        <div class="privacy">
          <a
            href="https://www.iubenda.com/privacy-policy/39740081"
            class="iubenda-white iubenda-noiframe iubenda-embed iubenda-noiframe"
            title="Privacy Policy "
            >Privacy Policy</a
          >
        </div>
        <div class="cookie">
          <a
            href="https://www.iubenda.com/privacy-policy/39740081/cookie-policy"
            class="iubenda-white iubenda-noiframe iubenda-embed iubenda-noiframe"
            title="Cookie Policy "
            >Cookie Policy</a
          >
        </div>
      </div>
      <div class="quamm underline-animation">
        <a href="https://www.quamm.it" target="_blank"> Quamm </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MenuFooter',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
